export const integrations = {
  seo: {
    title: 'Integrations – connect your favourite apps | Bistroo',
    description: 'Connect Lightspeed, Mollie, Exact and more with one click to Bistroo. View all available integrations for your restaurant.',
  },
  hero: {
    heading: {
      1: 'Your',
      2: 'favorite apps',
      3: 'integrated with a single click',
    },
    description: {
      1: 'We offer a wide range of integrations so you can focus on what you do best, without any hassle.',
      2: 'Our integrations make everything work together effortlessly, so you can focus on growing your business — not managing technology. Quick setup, smooth experience and no fuss.',
    },
  },
  cards: {
    card_1: {
      title: 'Choose your integration',
      text: 'Select your integration from our app marketplace in the Bistroo Manager.',
      button: 'View app marketplace',
      img_alt: '',
    },
    card_2: {
      title: 'Follow the guide',
      text: 'We provide you with the steps you need to follow for a smooth integration process.',
      button: '',
      img_alt: '',
    },
    card_3: {
      title: 'Activate the integration',
      text: 'Activate the integration in the Bistroo management app and start exchanging data.',
      button: '',
      img_alt: '',
    },
    card_4: {
      title: 'Questions?',
      text: 'Do you have questions or would you like someone to look over your integration? Feel free to contact us.',
      button: '',
      img_alt: '',
    },
    card_5: {
      title: 'You are ready to go!',
      text: 'After completing these steps, your software is fully integrated.',
      button: '',
      img_alt: '',
    },
  },
  partner: {
    title: 'Want to become a partner?',
    text: {
      1: 'Sign up soon via our partner portal. Until then, feel free to',
      2: 'contact us',
      3: '.',
    },
  },
}
